<div class="gauge-container">
    <svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="!isOnProjectTeam ? ('0 0 '+ (width + 40) + ' ' + (height + 35)) : ('0 0 '+ 160 + ' ' + 135)">
      <path
        [attr.d]="backgroundPath"
        [attr.stroke]="backgroundColor"
        stroke-width="34"
        fill="none"
        stroke-linecap="round"
      />
      <path
        [attr.d]="gaugePath"
        [attr.stroke]="'url(#' + gaugeId + ')'"
        stroke-width="24"
        fill="none"
        stroke-linecap="round"
      />
      <linearGradient [attr.id]="gaugeId" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" [attr.stop-color]="colorStart"/>
        <stop offset="100%" [attr.stop-color]="colorEnd"/>
      </linearGradient>
    </svg>

    <div [ngClass]="{'for-project-team':isOnProjectTeam}" class="gauge-value">
      <img *ngIf="trend === 'up'" src="../../../assets/svg/gauge-arrow-up.svg">
      <img *ngIf="trend === 'down'" src="../../../assets/svg/gauge-arrow-down.svg">
      <span class="value">{{ value }}</span>
      <span class="percent">%</span>
    </div>
</div>

